import errorHandle from '../../../utils/errorHandle';
import { CheckTrip } from '../../../api/userAPI';

export default async function fetchTripCheck(type, packId, setCheckTrip) {
    try {
        const res = await CheckTrip(type, packId);
        setCheckTrip(res);
    } catch (error) {
        errorHandle(error);
    }
}
